<template>
	<div id='warp_div'>
		<a-popover :visible="visible" placement="top" trigger="click" :destroyTooltipOnHide="true"
			:overlayStyle="{width:'calc(25rem)'}" @visibleChange="moreEvent()"
			:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div>
				<a-form-model ref='ruleForms' :model="formmin" labelAlign='left' layout="inline"
					hideRequiredMark>
					<div id='on-center'>
						<!-- <a-form-model-item label="保薦機構" prop='info'> -->
							<a-textarea v-model="formmin.info" :auto-size="{ minRows: 4, maxRows: 5 }"
								style='width: 23.2rem;'  placeholder="多個保薦機構請用分號分隔" class='warp_width' />
								<!-- :maxLength='200' -->
							<!-- <span
								style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{formmin.info.length}}/200</span> -->
						<!-- </a-form-model-item> -->
						</div>
						</a-form-model>
						</div>
			</template>
			<img title='點擊添加更多' src="@/image/images.png" style="z-index:1111;cursor: pointer;
			position: absolute;right: 0.2rem;width: .7rem;top: 0.2rem;"
			alt="" @click='fundefan'>
		</a-popover>
	</div>
</template>
<script>
	
	export default {
		props: ['ishand','forms'],
		data() {
			return {
				visible:false,
				formmin:{
					info:this.forms.baojianr
				},
				loading:false,
			}
		},
			// mounted() {
			// 	console.log(this.ishand,this.forms.baojianr)
			// },
			methods: {
				fundefan(){
					// this.visible = !this.visible
				},
				handleCancel(){
					this.$emit('child',false)
				},
				handleOk(){
					console.log(this.formmin.info)
					// if(this.formmin.info){
						this.$emit('child',false,this.formmin)
					// }
				},
				//彈出前操作
				moreEvent() {
					this.visible = !this.visible
					// if (this.visible) {
					// 	this.visible = false
					// } else {
					// 	if (this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0) {
					// 		App.oTool.warningT('無更多操作權限');
					// 	} else if (this.params.missionflag) {
					// 		App.oTool.warningT('審核狀態無法進行更多操作');
					// 	} else {
					// 		this.visible = true
					// 	}
					// }
				},
			}
			
		}
</script>

<style>
</style>
